import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import * as hopDongConstant from './constants'
import * as hopDongAction from './actions'
import { storedb } from '../../views/client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { ButtonExt } from "../controls/ButtonExt"
import { confirmAlert } from 'react-confirm-alert';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import Moment from "react-moment";
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
class HopDong extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      item: {},
      list: [],
      keyword: '',
      per_page: 20,
      page: 1,
      total_record: 0,
      khachHangId: 0
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  fetchList = () => {
    const { hopDongListRequest } = this.props
    var requestData = {
      khachHangId: this.state.khachHangId,
      keyword: this.state.keyword,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return hopDongListRequest(requestData);
  }
  search = () => {
    if (this.props.hopDong.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  refresh = () => {
    this.setState({
      stores_id: this.state.stores_id,
      keyword: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.hopDong.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  EditHopDongItem = (item, e) => {
    this.props.history.push('/hopdong-edit?kid=' + this.state.khachHangId + '&id=' + (item.Id || ""));
  }
  processRemoveClick = (item) => {
    if (!item.Id && item.Id <= 0) {
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn muốn xóa hợp đồng <b className="text-danger">{item.Ten}</b> không?</p>
            <button className="text-danger" onClick={() => {
              this.processRemoveItem(item)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  processRemoveItem = (item) => {
    var requestData = {
      StoreId: this.state.stores_id,
      Id: item.Id,
    }
    return this.props.hopDongRemoveRequest(requestData, () => {
      this.fetchList()
    });
  }
  componentDidMount() {
    let khachHangId = this.getParam("kid");
    if (khachHangId && khachHangId > 0) {
      this.setState({ khachHangId: khachHangId }, () => {
        this.fetchList();
      })
    } else {
      this.props.history.push('/khachhang');
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.hopDong.type == hopDongConstant.HOPDONG_LIST_SUCCESS) {
      let { list, item } = nextProps.hopDong;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    }
  }
  render() {
    const {
      handleSubmit,
      hopDong: {
        listRequesting,
        list,
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." open={true}>
              <Row>
                <Col sm="12" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Thông tin hợp đồng</InputGroupAddon>
                    <Input name="keyword" placeholder="Tên/Số hợp đồng" value={this.state.keyword} onChange={this.handleSearchChange.bind(this, "keyword")} />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1"
                onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <ButtonExt className="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditHopDongItem({})}
                permission={""} />
            </div>
            <div className="w-100">
              <Row>
                <Col md="12">
                  {!isRequesting && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {!isRequesting && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </Col>
              </Row>
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Tên/số hợp đồng</th>
                    <th scope="col" className="text-left">Từ ngày</th>
                    <th scope="col" className="text-left">Đến ngày</th>
                    <th scope="col" className="text-right">Chiết khấu</th>
                    <th scope="col" className="text-right">Tổng giá trị</th>
                    <th scope="col" className="text-left">Trạng thái</th>
                    <th scope="col" className="text-left">Ghi chú</th>
                    <th scope="col" width="50" className="text-center">Sửa</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.TenHopDong}</td>
                        <td className="text-left">{res.TuNgay && <Moment format="DD/MM/YYYY">{`${res.TuNgay}`}</Moment>}</td>
                        <td className="text-left">{res.DenNgay && <Moment format="DD/MM/YYYY">{`${res.DenNgay}`}</Moment>}</td>
                        <td className="text-right">{parseFloat(res.ChietKhau || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat(res.TongGiaTri || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left">{res.TrangThai == 1 ? "Có hiệu lực" : "Hết hiệu lực"}</td>
                        <td className="text-left">{res.GhiChu}</td>
                        <td scope="row" className="text-center">
                          <ButtonExt
                            btnClass="text-primary"
                            iconClass="fa-edit fa-lg"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.EditHopDongItem(res)}
                            permission={''} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  hopDong: state.hopDong,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  hopDongListRequest: hopDongAction.hopDongListRequest,
  hopDongUpdateRequest: hopDongAction.hopDongUpdateRequest,
  hopDongRemoveRequest: hopDongAction.hopDongRemoveRequest
})(HopDong)
const formed = reduxForm({
  form: 'hopDong',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/HopDong/HopDong.js